export default __webpack_public_path__ + "static/media/solvio-landing-page.e5166ef8.png";